import { z } from "zod";

export default () => z.object({
    label: z.string().trim().min(1),
});
